<div [class.show]="isOpenDrawer" class="drawer-wrapper">
  <div class="overlay" (click)="closeDialog()"></div>
  <div class="drawer">
    <div class="header">
      <div class="title">
        {{ title }}
        <span (click)="closeDialog()" class="material-icons side-nav-bar-close">clear</span>
      </div>
    </div>
    <div class="body">
      <ng-content></ng-content>
    </div>
    <div class="footer">
      <app-bulgari-button *ngIf="confirmButton" (click)="callback.emit(true)" [type]="'black'"
        [customStyle]="{width: '100%'}" [text]="confirmButton | uppercase"></app-bulgari-button>
    </div>
  </div>
</div>
